import React from "react";
import { Divider, Flex } from "@chakra-ui/react";
import { VeriDatePickerContainerProps } from "./VeriDatePickerContainer.types";
import { VeriDatePickerHeader } from "../VeriDatePickerHeader";
import VeriDatePickerBody from "../VeriDatePickerBody/VeriDatePickerBody";
import { useVeriDatePicker } from "../VeriDatePickerContext";
import { isValidInputDateDob, isValidYYYYMMDDDate } from "../../../utils/dates";
import { getDateValue } from "../utils";

const VeriDatePickerContainer: React.FC<VeriDatePickerContainerProps> = ({
  onDateChange,
  value,
  rangeStartDate,
  rangeEndDate,
  ...rest
}) => {
  const datePicker = useVeriDatePicker();

  // Updates from outside
  React.useEffect(() => {
    if (!value || !isValidInputDateDob(value || "")) return;

    const newDateStr = getDateValue(value);
    if (newDateStr) datePicker.setDateValue(newDateStr);
  }, [value]);

  React.useEffect(() => {
    datePicker.setRangeDates(
      (rangeStartDate &&
        isValidYYYYMMDDDate(rangeStartDate || "") &&
        rangeStartDate) ||
        "",
      (rangeEndDate &&
        isValidYYYYMMDDDate(rangeEndDate || "") &&
        rangeEndDate) ||
        "",
    );
  }, [rangeStartDate, rangeEndDate]);
  return (
    <Flex direction="column" w={"390px"} h={"340px"} {...rest}>
      <VeriDatePickerHeader />
      <Divider />
      <VeriDatePickerBody />
    </Flex>
  );
};

export default VeriDatePickerContainer;
